import { AsyncPipe, NgIf, NgTemplateOutlet } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatSidenavModule } from "@angular/material/sidenav";
import { RouterOutlet } from "@angular/router";
import { VexProgressBarComponent } from "@vex/components/vex-progress-bar/vex-progress-bar.component";
import { VexSidebarComponent } from "@vex/components/vex-sidebar/vex-sidebar.component";
import { BaseLayoutComponent } from "@vex/layouts/base-layout/base-layout.component";
import { ConfigPanelToggleComponent } from "@vex/layouts/components/config-panel/config-panel-toggle/config-panel-toggle.component";
import { ConfigPanelComponent } from "@vex/layouts/components/config-panel/config-panel.component";
import { FooterComponent } from "@vex/layouts/components/footer/footer.component";
import { SearchComponent } from "@vex/layouts/components/new-toolbar/search/search.component";
import { QuickpanelComponent } from "@vex/layouts/components/quickpanel/quickpanel.component";
import { SidenavComponent } from "@vex/layouts/components/sidenav/sidenav.component";
import { ToolbarModule } from "@vex/layouts/components/toolbar/toolbar.module";
import { AboutModule } from "src/bio-cloud/app/about/about.module";
import { CustomLayoutComponent } from "./custom-layout.component";




@NgModule({
  declarations: [CustomLayoutComponent],
  imports: [
    BaseLayoutComponent,
    AboutModule,
    NgIf,
    AsyncPipe,
    SidenavComponent,
    ToolbarModule,
    FooterComponent,
    QuickpanelComponent,
    ConfigPanelToggleComponent,
    VexSidebarComponent,
    ConfigPanelComponent,
    MatDialogModule,
    MatSidenavModule,
    NgTemplateOutlet,
    RouterOutlet,
    SearchComponent,
    VexProgressBarComponent
  ]
})
export class CustomLayoutModule {
}
